import React, { useContext } from 'react'
import styles from './index.module.less'
import classnames from 'classnames'

import context from '../../context'

function Process() {
  const {
    process: { first, second, third },
    lang,
  } = useContext(context)

  return (
    <div className={styles.process}>
      <div className={classnames(styles.tips, styles[lang])} />
      <div className={styles.detail}>
        <div className={styles.item}>
          <div>
            <span>01</span>
            <em></em>
          </div>
          <div>{first}</div>
        </div>
        <div className={styles.item}>
          <div>
            <span>02</span>
            <em></em>
          </div>
          <div>{second}</div>
        </div>
        <div className={styles.item}>
          <div>
            <span>03</span>
          </div>
          <div>{third}</div>
        </div>
      </div>
    </div>
  )
}

export default Process
